export default function AfterH5(props: any) {
    return (
        <svg width="66" height="216" viewBox="0 0 66 216" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle
                cx="60.0492"
                cy="212.049"
                r="3.2"
                transform="rotate(-0.947326 60.0492 212.049)"
                fill="url(#paint0_linear_950_5889)"
                stroke="url(#paint1_linear_950_5889)"
                strokeWidth="0.4"
            />
            <circle
                cx="3.42743"
                cy="16.4274"
                r="2.58827"
                transform="rotate(-0.947326 3.42743 16.4274)"
                fill="url(#paint2_linear_950_5889)"
                stroke="url(#paint3_linear_950_5889)"
                strokeWidth="0.4"
            />
            <path
                d="M77.5967 129.024C77.7991 128.869 77.8211 128.591 77.7901 128.33C77.7569 128.051 77.6524 127.699 77.4914 127.289C77.1682 126.466 76.5987 125.365 75.8331 124.066C74.3004 121.466 71.966 118.048 69.1933 114.425C66.4206 110.803 63.7304 107.657 61.6209 105.498C60.5672 104.42 59.6531 103.583 58.943 103.056C58.5892 102.793 58.2764 102.6 58.016 102.496C57.7723 102.398 57.4983 102.346 57.296 102.501C57.0936 102.656 57.0715 102.934 57.1026 103.195C57.1358 103.474 57.2403 103.826 57.4013 104.236C57.7245 105.059 58.294 106.16 59.0596 107.459C60.5923 110.059 62.9267 113.477 65.6993 117.1C68.472 120.722 71.1623 123.868 73.2717 126.026C74.3255 127.105 75.2396 127.942 75.9497 128.469C76.3034 128.731 76.6162 128.924 76.8766 129.029C77.1203 129.127 77.3943 129.178 77.5967 129.024Z"
                fill="url(#paint4_linear_950_5889)"
                stroke="url(#paint5_linear_950_5889)"
                strokeWidth="0.4"
            />
            <defs>
                <linearGradient id="paint0_linear_950_5889" x1="63.0492" y1="205.487" x2="67.739" y2="212.243" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_950_5889" x1="59.6329" y1="207.165" x2="63.5038" y2="207.285" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint2_linear_950_5889" x1="5.8157" y1="11.2031" x2="9.5492" y2="16.582" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint3_linear_950_5889" x1="3.09601" y1="12.5388" x2="6.17758" y2="12.6344" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint4_linear_950_5889" x1="47.0965" y1="85.8852" x2="55.497" y2="81.5074" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint5_linear_950_5889" x1="50.897" y1="94.5976" x2="52.954" y2="93.0353" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
            </defs>
        </svg>
    );
}
